import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import firebase from "firebase";
import { get, cloneDeep, set, forEach } from "lodash";
import schemas from "./content-types";
import Table from "../../Table";
import { withRouter } from "react-router-dom";
import { Box } from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import Toolbar from "../../Toolbar";
import Dialog from "../../ui/Dialog";
import _actions from "../../../_actions";
import Stack from "../../ui/Stack";
import ContentEntry from "./ContentEntry";
import { createSubscription, batchUpdate } from "../../../utils/db";

const ContentTypeEntries = props => {
  const { match, history } = props;
  const [showDialog, setShowDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState(false);
  const [useRow, setUseRow] = useState();
  const [schema, setSchema] = useState(schemas[match.params.schemaId]);
  // const [fetched, setFetched] = useState(false);
  // const [hasSet, setHasSet] = useState(false);

  const [data, setData] = useState(props.entries);

  useEffect(() => {
    setData(props.entries);
  }, [props.entries]);

  useEffect(() => {
    setSchema(schemas[match.params.schemaId]);
  }, [match.params.schemaId]);

  // useEffect(() => {
  //   if (schema.ref === "products" && !hasSet) {
  //     console.log(props.db);
  //     // console.log({ db: props.db });
  //     const sudoUpdates = {};
  //     forEach(cloneDeep(props.entries), (entry, index) => {
  //       sudoUpdates[index] = entry;
  //       // console.log(index, { entry });
  //       forEach(entry.classification, (c, i) => {
  //         set(
  //           sudoUpdates,
  //           `${index}.classification.${i}`,
  //           get(props.db, `classification.${c}.id`, c)
  //         );
  //       });

  //       forEach(entry.brand, (c, i) => {
  //         set(
  //           sudoUpdates,
  //           `${index}.brand.${i}`,
  //           get(props.db, `brands.${c}.id`, c)
  //         );
  //       });
  //     });

  //     console.log(sudoUpdates);

  //     // batchUpdate({
  //     //   data: sudoUpdates,
  //     //   ref: `${schema.ref}_backup`,
  //     //   method: "set"
  //     // });

  //     batchUpdate({
  //       data: sudoUpdates,
  //       ref: schema.ref,
  //       method: "update"
  //     });
  //     setHasSet(true);
  //     // setData({ ...sudoUpdates });
  //   }
  // }, [props.entries, schema.ref, props.db, hasSet]);

  createSubscription(schema.ref);

  const confirmDelete = row => {
    setUseRow(row);
    setShowDialog(true);
    setDialogContent("Are you you sure you want to delete this item?");
  };

  const deleteRow = async () => {
    await firebase
      .firestore()
      .collection(schema.ref)
      .doc(useRow.id)
      .delete();
    setUseRow(null);
    setShowDialog(false);
  };

  return (
    <>
      <Dialog
        maxWidth="xs"
        title="Delete"
        open={showDialog}
        onClose={() => setShowDialog(false)}
        buttons={[
          { label: "Cancel", onClick: () => setShowDialog(false) },
          {
            label: "Delete",
            onClick: deleteRow,
            color: "primary",
            variant: "contained"
          }
        ]}
      >
        <Box p={2}>{dialogContent}</Box>
      </Dialog>
      <Stack
        withHeader={false}
        size="large"
        onClose={() => props.history.push(`/edit/${schema.id}`)}
        show={match.params.entryId}
      >
        <ContentEntry {...props} />
      </Stack>
      <Box>
        <Toolbar backUrl="/edit">
          {get(schema, "actions.create") !== false ? null : <div />}
        </Toolbar>
        <Box p={4}>
          <Table
            key={schema.ref}
            data={data}
            schema={schema}
            onRowClick={
              get(schema, "actions.update") !== false
                ? row => history.push(`${match.url}/${row.id}`)
                : () => {}
            }
            actions={[
              ...(get(schema, "actions.delete") !== false
                ? [
                    {
                      icon: <DeleteIcon />,
                      label: "Delete",
                      onClick: confirmDelete
                    }
                  ]
                : [])
            ]}
          />
        </Box>
      </Box>
    </>
  );
};

export default connect(
  ({ dbState }, props) => ({
    entries: get(
      dbState,
      get(schemas, [props.match.params.schemaId, "ref"]),
      {}
    ),
    db: dbState
  }),
  { setData: _actions.setData }
)(withRouter(ContentTypeEntries));
